// extracted by mini-css-extract-plugin
module.exports = {" _key":"demo/menuItem","root":"menuItem-m__root__3nC3w","item":"menuItem-m__item__2otQ-","selected":"menuItem-m__selected__3H86O"};